import React, { useState } from "react";
import { updateUserProfile } from "../api/users";
import "./ProfileCompletionModal.css";

export default function ProfileCompletionModal({ user, onClose, onComplete }) {
  const [formData, setFormData] = useState({
    current_location: user?.current_location || "",
    age: user?.partner_profile?.age || "",
    gender: user?.partner_profile?.gender || "",
    bio: user?.partner_profile?.bio || "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  function onChange(e) {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const updateData = {
        current_location: formData.current_location,
        partner_details: {
          age: parseInt(formData.age),
          gender: formData.gender,
          bio: formData.bio,
        },
      };

      await updateUserProfile(updateData);
      onComplete();
    } catch (err) {
      console.error("Profile update error:", err);
      setError(err.response?.data?.detail || "Failed to update profile. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  function handleSkip() {
    onClose();
  }

  return (
    <div className="profile-completion-modal-overlay">
      <div className="profile-completion-modal">
        <div className="modal-header">
          <h2>Complete Your Profile</h2>
          <p>Help other travelers learn more about you!</p>
        </div>

        <form onSubmit={handleSubmit} className="profile-completion-form">
          <div className="form-group">
            <label htmlFor="current_location">
              📍 Current Location <span className="required">*</span>
            </label>
            <input
              id="current_location"
              name="current_location"
              type="text"
              placeholder="e.g., New York, USA"
              value={formData.current_location}
              onChange={onChange}
              required
              className="form-control"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="age">
                🎂 Age <span className="required">*</span>
              </label>
              <input
                id="age"
                name="age"
                type="number"
                placeholder="Your age"
                value={formData.age}
                onChange={onChange}
                required
                min="18"
                max="100"
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="gender">
                ⚧️ Gender <span className="required">*</span>
              </label>
              <select
                id="gender"
                name="gender"
                value={formData.gender}
                onChange={onChange}
                required
                className="form-control"
              >
                <option value="">Select gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
                <option value="Prefer not to say">Prefer not to say</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="bio">
              📝 Bio (Optional)
            </label>
            <textarea
              id="bio"
              name="bio"
              placeholder="Tell us about yourself and your travel preferences..."
              value={formData.bio}
              onChange={onChange}
              className="form-control"
              rows="4"
            />
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <div className="modal-actions">
            <button
              type="button"
              onClick={handleSkip}
              className="btn-skip"
              disabled={isLoading}
            >
              Skip for now
            </button>
            <button type="submit" className="btn-submit" disabled={isLoading}>
              {isLoading ? "Saving..." : "Complete Profile"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
